import aor from "../../../images/aor2.png";
import dauth from "../../../images/dauth.png";
import cc from "../../../images/cc.png";
import arcadia from "../../../images/arcadia26.png";
import timeWarp from "../../../images/timeWarp.png"
import arhunt from "../../../images/arhunt.png"
import outbreak from "../../../images/outbreak.jpg"
import superhero from "../../../images/superheroes26.png"
import terrabound from "../../../images/terrabound26.jpeg"
import seawars from "../../../images/seawars.jpg"
export interface Project {
  name: string;
  description: string;
  image: string;
}

export const projects: Project[] = [
  {
    name: "Arcadia",
    description:
      "Arcadia Rivals is a fast-paced web-based arcade strategy game built using Phaser, TypeScript, and JavaScript, with a Golang backend powering real-time multiplayer interactions. Players compete by strategically deploying units, reacting instantly to opponents, and adapting to dynamic combat scenarios. The game emphasizes quick decision-making, tactical positioning, and smooth, low-latency gameplay, all supported by a scalable and efficient system design.",
    image:
     arcadia,
  },
  {
    name: "Superheroes",
    description:
      "Superheroes is a competitive real-time strategy game where players step into the role of heroes or villains across a live 3D city map, respond to dynamic crimes, and outplay opponents through coordination and minigames. Success depends on speed, planning, and precision under pressure. Players can also trigger strategic glitches to disrupt opponents and shift momentum at key moments.",
    image:
     superhero,
  },
  {
    name: "Seawars",
    description:
      "Seawars is a Bytehoc game where you write scripts in Python, managing a fleet of bots that harvest algae and battle it out against your enemy’s army. You’ll be writing a single-file Python script that manages the spawning, movement, and abilities of your bot army. The player with the highest algae after 1000 ticks (turns) wins, gaining ELO and facing tougher opponents next time.",
    image: seawars,
  },
  {
    name: "Attack On Robots",
    description:
      "Attack on Robots is a multiplayer resource management game based on strategic city planning. Participants attempt to design safe and secure cities with the available resources and attempt to find weaknesses in other cities. Each player designs a secure city for the robots using the given buildings and defenses.",
    image: aor,
  },
  {
    name: "Code Character",
    description:
      "Code Character is a strategy-based programming game wherein you control troops in turns using code written in one of the multiple programming languages (C++, Python, Java) available in the game. The objective is to destroy and conquer the opponent's territory by creating and writing strategic defences in code via the in-game map",
    image: cc,
  },
  {
    name: "DAuth",
    description:
      "DAuth is an OAuth2.0-based SSO (Single Sign On) for NITT students. It serves to replace existing webmail-based login and redundant registration. DAuth lets the application developers securely get access to users’ data without users having to share their passwords. It is more secure and easier to integrate with your services and use.",
    image: dauth,
  },
  {
    name: "Time Warp",
    description:
      "Timewarp is a single-player game wherein you solve puzzles after finding clues by interacting with the map and using your code editor to code your way to the next level. The game's objective is to solve as many puzzles as possible before the event runs out.",
    image: timeWarp,
  },
  {
    name: "Terrabound",
    description:
      "Terrabound is a strategy based multiplayer conquest, where players can fortify their defense,  attack with a masterplan trooplineup, all the while trying to keep the morale of your states high and elo increasing. As you compete with players in a high stake state capture environment, with skills enhanced by mining aurum and training troops, the deterministic combat simulation delivers an immersive technically robust game experience.",
    image: terrabound,
  },
  {
    name: "Outbreak Origins",
    description:
      "Outbreak Origins is a game which draws inspiration from the Plague Inc. franchise .  To save the lands Xyrus, Glaciallus and Pyros, players have to devise a game plan and strategically combat the devious virus to contain the proliferation of the virus before it plunges these regions into chaos.",
    image: outbreak,
  },
  {
    name: "AR Hunt",
    description:
      "AR Hunt is an Augmented Reality based Android treasure hunt game that enables freshers to explore the campus by solving clues and crossing a variable set of checkpoints to discover AR objects within a time constraint.",
    image: arhunt,
  },
];
